<template>
  <div class="place-card-wrapper" :class="{actionableWrapper: !isDetailsDisabled}">
    <button class="close-btn" @click="$emit('remove')" v-if="isUnscheduled && !isLoading">
      <IconCross class="close-icon" />
      remove
    </button>
    <div
      class="column btn-clear place-card"
      @click="onShowDetails"
      :class="{loading: isLoading, actionableCard: !isDetailsDisabled}"
    >
      <transition name="fade-in">
        <div class="content">
          <!-- <div class="recommendation" v-if="isRecommendation && !isLoading">Recommended</div> -->
          <div class="mb-s placeImage" :class="{actionableImage: !isDetailsDisabled}">
            <img v-if="!isLoading" :src="activityImg" alt="" />
            <slot name="image" v-if="!isLoading" />
          </div>
          <div class="t-copy dark activity-name">
            <strong>{{ activityName }}</strong>
          </div>
          <div class="t-copy sm mb-s activity-description" v-if="!isUnscheduled">{{ description }}&nbsp;</div>
          <div >
            <POIRelations :class="{hidden:! allPois.length}" :pois="allPois" :isParent="!hasParent" />
          </div>
          <div class="card-data" v-if="!isUnscheduled && !isLoading">
            <div class="price" v-if="price && isStay">Price: {{ price }}</div>
            <div class="price" v-if="price && !isStay">Rated: {{ price }}</div>
            <div class="rating" v-if="rating">{{ rating }}</div>
            <div class="place" v-if="address">{{ address }}</div>
          </div>
          <div class="tags" v-if="!isUnscheduled">
            <div class="gradientFadeoutRight"></div>
            <div class="inner">
              <div class="tag" v-for="tag in activityTags" :key="tag.name" :class="{withchecks: tag.isActive}">
                {{ tag.name }}
              </div>
            </div>
          </div>
          <!-- <div class="cost">
            <div class="cost-aligner">
              <div class="rating-wrapper" v-if="isRatingShown && !isUnscheduled">
                <StarRating
                  class="star-rating"
                  v-if="rating"
                  :rating="rating"
                  read-only
                  :star-size="12"
                  :increment="0.1"
                />
              </div>

              <div class="actions-slot-wrapper">
                <slot name="actions">

                </slot>
              </div>
              <div class="price-wrapper" v-if="!isUnscheduled">
                <div class="caption"><slot /></div>
                <div>{{ price }}</div>
              </div>
            </div>
          </div> -->
          <!-- <slot/> -->
          <slot name="actions" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {usePlaceCardLogic} from '@common/place-card-logic/place-card-logic';
import VueCompositionAPI from '@vue/composition-api';
import POIRelations from './poi-relations.vue';
Vue.use(VueCompositionAPI);

// import StarRating from 'vue-star-rating';
import IconCross from '@components/svg/cross.vue';

export default {
  components: {
    POIRelations,
    IconCross,
  },
  props: {
    activity: Object,
    isLoading: {
      type: Boolean,
      default: false,
    },
    isRatingShown: {
      type: Boolean,
      default: true,
    },
    isUnscheduled: {
      type: Boolean,
      default: false,
    },
    isDetailsDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onSelectItem() {
      this.$emit('item-selected');
    },
    onShowDetails() {
      this.$emit('show-details');
    },
  },
  setup(props) {
    return usePlaceCardLogic(props);
  },
};
</script>

<style lang="postcss" scoped>
.hidden {
  opacity: 0;
}
.place-card {
  position: relative;
  transition: box-shadow 0.5s cubic-bezier(0.075, 0.82, 0.165, 1),
    background-color 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
  /* border-radius: 10px; */
  border-radius: var(--card-br, 10px);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  max-width: var(--card-max-width, 300px);
  width: 100%;
}

.actionableCard {
  cursor: pointer;
}

.actionableWrapper.place-card:hover {
  background: #ffffff;
}
.place-card:hover {
  /* & .amex-primary-btn {
    opacity: 1;
    z-index: 1;
    pointer-events: auto;
  } */
  & .star-rating {
    /* opacity: 0; */
    pointer-events: none;
  }

  & .actionableImage:after {
    content: 'Read More';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: var(--shadingB-40);
    color: var(--toneBw-0);
    border-radius: var(--radiusSmall);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s ease opacity;
  }
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.placeImage {
  width: 100%;
  height: 0;
  padding-top: 50%;
  position: relative;

  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    top: 0;
    left: 0;
    position: absolute;
    border-radius: var(--radiusSmall);
  }
}

.tags {
  position: relative;
  width: 100%;
}
.tags .inner {
  width: 100%;
  margin: 0 -5px 0 -4px;
  white-space: nowrap;
  overflow: auto;
  padding-top: 10px;
  padding-bottom: 0px;
  border-top: 1px solid var(--toneBw-5);
  &::-webkit-scrollbar {
    display: none;
  }
}

.gradientFadeoutRight {
  background: linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 50px;
  pointer-events: none;
  z-index: 1;
}

.tag {
  position: relative;
  border-radius: 4px;
  font-size: 13px;
  padding: 5px 10px 3px;
  display: inline-block;
  margin: 4px;
  text-transform: capitalize;
  background-position: 8px center;
  background-repeat: no-repeat;
  background-size: 6px;
  border: 1px solid var(--toneBw-20);
  color: var(--toneBw-20);
}

.tag.withchecks {
  border: 1px solid var(--tonePreferences-100);
  color: var(--tonePreferences-100);
  background-image: var(--iconPreferenceCheckPrimary);
  padding-left: 20px;
  /* background-color: #f1f1f1; */
  /* color: inherit; */
}

/* .tag.withchecks::before {
  content: '';
  position: absolute;
  top: 3px;
  right: 3px;
  margin: -8px -8px 0 0;
  opacity: 1;
  transform: none;
  width: 12px;
  height: 12px;
  border-radius: 14px;
  background-color: #a3abb6;
  border: 2px solid #fff;
  background-image: url("data:image/svg+xml,%3Csvg width='6' height='5' viewBox='0 0 6 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.3215 0.617066C5.53299 0.794617 5.56051 1.11 5.38296 1.3215L2.86444 4.3215C2.76944 4.43466 2.62925 4.50001 2.48149 4.50001C2.33374 4.50001 2.19355 4.43466 2.09855 4.3215L0.617066 2.55679C0.439515 2.3453 0.467031 2.02991 0.678526 1.85236C0.890021 1.67481 1.20541 1.70233 1.38296 1.91382L2.48149 3.22237L4.61707 0.678526C4.79462 0.467031 5.11 0.439515 5.3215 0.617066Z' fill='white'/%3E%3C/svg%3E%0A");
  background-size: 7px;
  background-position: 1px 1px;
  background-repeat: no-repeat;
} */

.cost {
  margin-top: 15px;
  font-size: 18px;
  line-height: 0.9em;
  display: flex;
  justify-content: space-between;
  flex: 1;
}

.cost-aligner {
  align-self: flex-end;
  display: flex;
  width: 100%;
}

.caption {
  font-size: 10px;
  color: #a3abb6;
}

.btn-clear {
  background: none;
  border: none;
  -webkit-appearance: none;
  text-align: left;
  /* cursor: pointer; */
}

.rating-wrapper {
  position: relative;
  float: left;
  width: 0;
}

.price-wrapper {
  margin-left: auto;
}

.star-rating {
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.2s ease-in-out;
}

/* .amex-primary-btn {
  transition: opacity 0.2s ease-in-out;
  border: none;
  background: none;
  color: #fff;
  background-color: var(--btn-primary-color, hsl(208, 100%, 41%));
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  border-radius: 10px;
  padding: 10px 12px 7px;
  letter-spacing: 0.01em;
  cursor: pointer;
  position: relative;
  opacity: 0;
  pointer-events: none;

  &:hover {
    background-color: var(--btn-primary-color-active, hsl(208, 100%, 30%));
  }
} */

.activity-name,
.activity-description {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.activity-description {
  ont-size: var(--tSize-sm);
}

.card-data {
  border-top: 1px solid var(--toneBw-5);
  padding-top: 10px;
  padding-bottom: 8px;
  font-size: var(--tSize-sm);
  color: var(--toneTDark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: flex;
}

.rating,
.price,
.place {
  display: inline-block;
  background-size: 11px;
  background-position: left 18%;
  background-repeat: no-repeat;
  padding-left: 16px;
  padding-right: 10px;
  background-image: var(--iconRating);
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
}
.place {
  background-image: var(--iconPlace);
  flex-shrink: 1;
}
.price {
  background-image: var(--iconPrice);
}
</style>

<style>
.vue-star-rating-rating-text {
  font-size: 12px;
  color: #a3abb6;
  position: relative;
  top: -3px;
}
</style>

<style scoped>
.loading .placeImage {
  position: relative;
  overflow: hidden;
  background: #f1f1f1;
  /* border-radius: var(--card-br, 10px); */
  border-radius: 10px;
}

.place-card.loading {
  pointer-events: none !important;
}

.place-card.loading .placeImage:after {
  content: none;
}

.loading .activity-name {
  background: #f1f1f1;
  width: 80%;
  height: 23px;
  border-radius: 10px;
  margin-top: 10px;
}

.loading .actions-slot-wrapper {
  display: none;
}

.place-card.loading .placeImage::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(to right, transparent 0%, #e8e8e8 50%, transparent 100%);
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

@keyframes load {
  from {
    left: -150px;
  }
  to {
    left: 100%;
  }
}

.actions-slot-wrapper {
  flex: 1;
}

.loading .activity-description {
  background: #f1f1f1;
  border-radius: 10px;
  width: 50%;
  height: 16px;
}

.loading .price-wrapper {
  display: none;
}

.recommendation {
  border-radius: 3px;
  padding: 5px;
  background: var(--recommendations-primary, #e9a43d);

  font-size: 14px;
  font-weight: 700;

  color: #fff;
  position: absolute;
  top: 25px;
  right: 0;
  z-index: 1;
}

.content-container > .place-card-wrapper {
  display: inline-block;
  position: relative;
  width: calc(33% - 11px);
}

.actionableWrapper:hover {
  /* box-shadow: 0px 0px 33px rgba(0, 0, 0, 0.13); */
}

.close-btn {
  font-size: 0;
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 10px;
  z-index: 1;
  color: #fff;
  cursor: pointer;
  appearance: none;
  border: none;
  background: none;
  background-color: rgba(0, 0, 0, 0.4);
  transition: 0.3s ease background;
  border-radius: 0 0px 0 10px;
}

.close-btn:hover {
  color: #e1e1e1;
}
.close-icon {
  font-size: 24px;
}
</style>
